export const LocationOptions = [
  { value: "ahmedabad", label: "Ahmedabad" },
  { value: "mumbai", label: "Mumbai" },
  { value: "delhi", label: "Delhi" },
  { value: "bangalore", label: "Bangalore" },
  { value: "pune", label: "Pune" },
];


export const CountryOptions = [
  { value: "india", label: "India", name: "India" },
  { value: "united_states", label: "United States", name: "United States" },
  { value: "united_kingdom", label: "United Kingdom", name: "United Kingdom" },
  { value: "canada", label: "Canada", name: "Canada" },
  { value: "germany", label: "Germany", name: "Germany" },
];

export const UserTypedata = [
  { value: "admin", label: "Admin", name: "Admin" },
  { value: "user", label: "User", name: "User" }, 
];

